import { ReactElement } from 'react';
import {
    ArrowDropDownCircleOutlined,
    AssignmentOutlined,
    AttachMoneyOutlined,
    BusinessOutlined,
    CalendarMonthOutlined,
    CheckCircleOutline,
    DescriptionOutlined,
    EmailOutlined,
    FlakyOutlined,
    RuleOutlined,
    FlightOutlined,
    Inventory2Outlined,
    LabelOutlined,
    LocalShippingOutlined,
    LocationOnOutlined,
    LockOutlined,
    NumbersOutlined,
    PersonOutlineOutlined,
    PhoneOutlined,
    PlusOneOutlined,
    QrCode2Outlined,
    ScaleOutlined,
    ScheduleOutlined,
    ShoppingCartOutlined,
    StarBorderOutlined,
    TextFieldsOutlined,
    WarehouseOutlined,
} from '@mui/icons-material';
import { CustomFieldType, customFieldTypeConfig } from '../../../../../ts/CustomFieldType';

// Icon names the custom fields API may specify; anything unrecognized falls back to the field type icon.
const CUSTOM_FIELD_ICONS: Record<string, ReactElement> = {
    assignment: <AssignmentOutlined />,
    barcode: <QrCode2Outlined />,
    business: <BusinessOutlined />,
    calendar: <CalendarMonthOutlined />,
    carrier: <LocalShippingOutlined />,
    check: <CheckCircleOutline />,
    checkbox: <RuleOutlined />,
    date: <CalendarMonthOutlined />,
    description: <DescriptionOutlined />,
    dropdown: <ArrowDropDownCircleOutlined />,
    email: <EmailOutlined />,
    flight: <FlightOutlined />,
    increment: <PlusOneOutlined />,
    inventory: <Inventory2Outlined />,
    label: <LabelOutlined />,
    location: <LocationOnOutlined />,
    lock: <LockOutlined />,
    money: <AttachMoneyOutlined />,
    numbers: <NumbersOutlined />,
    order: <ShoppingCartOutlined />,
    person: <PersonOutlineOutlined />,
    phone: <PhoneOutlined />,
    qrcode: <QrCode2Outlined />,
    scale: <ScaleOutlined />,
    schedule: <ScheduleOutlined />,
    shipping: <LocalShippingOutlined />,
    star: <StarBorderOutlined />,
    text: <TextFieldsOutlined />,
    warehouse: <WarehouseOutlined />,
};

export function customFieldIcon(iconName?: string, fieldType?: CustomFieldType): ReactElement {
    const key = iconName?.toLowerCase().replace(/[\s_-]/g, '');
    return (key && CUSTOM_FIELD_ICONS[key]) || CUSTOM_FIELD_ICONS[customFieldTypeConfig(fieldType).icon];
}
